import { get,} from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";
import { CreateUrlFilter } from "helpers/CreateURLFilter";

export const getUserAdvertList= async (filter:any): Promise<DataResponse<any>> => {
    const query = filter?CreateUrlFilter(filter):null
    const url = `${endpoints.getUserAdvertList}?${query}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const getUserAdvertStatusInfoes= async (): Promise<DataResponse<any>> => {

    const url = `${endpoints.getUserAdvertStatusInfo}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };